import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { retrieve, reset } from '../../actions/song/show';
import { all, reset as resetList } from '../../actions/song/list';
import { pick } from '../../actions/song/available';
import Display from './Display';

const styles = theme => ({
    leftColumn: {
        float: 'left',
        width: '70%'
    },
    rightColumn: {
        float: 'right',
        maxHeight: '100vh',
        overflow: 'auto',
        paddingLeft: '10px',
        width: '30%'
    },
    rButton: {
        position: 'absolute',
        top: 5,
        right: 5
    }
});

class Leader extends Component {
    static propTypes = {
        error: PropTypes.string,
        loading: PropTypes.bool.isRequired,
        retrieved: PropTypes.object,
        songList: PropTypes.array,
        retrieve: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        all: PropTypes.func.isRequired,
        resetList: PropTypes.func.isRequired
    };

    componentDidMount() {
        const { all, retrieve } = this.props;
        all();
        retrieve('/songs/current');
        this.refresh = setInterval(() => {
            retrieve('/songs/current');
            all();
        }, 5000);
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetList();
        clearInterval(this.refresh);
    }

    state = {
        anchorEl: null
    };

    pickSong = songId => {
        const { all, pick } = this.props;

        pick(songId).then(() => {
            all();
        });
    };

    render() {
        const item = this.props.retrieved;
        const { classes, retrieve, songList } = this.props;

        return (
            <div>
                <div className={classes.leftColumn}>
                    {item && (
                        <Display
                            showChords={true}
                            item={item}
                            includeNextSong={true}
                            nextAction={() => retrieve('/songs/next')}
                        />
                    )}
                </div>
                {songList && (
                    <div className={classes.rightColumn}>
                        <h3>Picked</h3>
                        <List>
                            {songList
                                .filter(item => {
                                    return item.pickedAt;
                                })
                                .sort((a, b) => {
                                    if (a.pickedAt < b.pickedAt) {
                                        return -1;
                                    }
                                    if (b.pickedAt < a.pickedAt) {
                                        return 1;
                                    }
                                    return 0;
                                })
                                .map(song => {
                                    return (
                                        <ListItem key={song.id} button>
                                            <ListItemText
                                                primary={song.title}
                                            />
                                        </ListItem>
                                    );
                                })}
                        </List>
                        <h3>Not Picked</h3>
                        <List>
                            {songList
                                .filter(item => {
                                    return !item.pickedAt;
                                })
                                .sort((a, b) => {
                                    if (a.title < b.title) {
                                        return -1;
                                    }
                                    if (b.title < a.title) {
                                        return 1;
                                    }
                                    return 0;
                                })
                                .map(song => {
                                    return (
                                        <ListItem
                                            key={song.id}
                                            button
                                            onClick={() =>
                                                this.pickSong(song.id)
                                            }
                                        >
                                            <ListItemText
                                                primary={song.title}
                                            />
                                        </ListItem>
                                    );
                                })}
                        </List>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        error: state.song.show.error,
        loading: state.song.show.loading,
        retrieved: state.song.show.retrieved,
        songList: state.song.list.data['hydra:member']
    };
};

const mapDispatchToProps = dispatch => {
    return {
        pick: songId => dispatch(pick(songId)),
        retrieve: id => dispatch(retrieve(id)),
        reset: () => {
            dispatch(reset());
        },
        all: () => dispatch(all()),
        resetList: () => {
            dispatch(resetList());
        }
    };
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Leader)
);



// WEBPACK FOOTER //
// ./src/components/song/Leader.js